import { apiFetch } from './client';

export async function adminListUsers() {
  return apiFetch('/users');
}

export async function adminSearchUsers({ q, role, active_only = true, limit = 10 }) {
  const params = new URLSearchParams();
  params.set('q', q);
  if (role) {
    params.set('role', role);
  }
  params.set('active_only', String(active_only));
  params.set('limit', String(limit));
  return apiFetch(`/users/search?${params.toString()}`, { method: 'GET' });
}

export async function adminInviteUser(userId) {
  return apiFetch(`/users/${userId}/invite`, { method: 'POST' });
}

export async function resendLinkedStudentInvites(studentId) {
  return apiFetch(`/admin/users/students/${studentId}/resend-invites`, { method: 'POST' });
}

export async function adminUpdateUser(userId, payload) {
  return apiFetch(`/users/${userId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function adminListInviteRequests({ status = 'PENDING', limit = 200 } = {}) {
  const params = new URLSearchParams();
  params.set('status', status);
  params.set('limit', String(limit));
  return apiFetch(`/users/invite-requests?${params.toString()}`, { method: 'GET' });
}

export async function adminApproveInviteRequest(id, payload = {}) {
  return apiFetch(`/users/invite-requests/${id}/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function adminRejectInviteRequest(id) {
  return apiFetch(`/users/invite-requests/${id}/reject`, {
    method: 'POST',
  });
}

export async function adminGetTutorStudents(tutorUserId) {
  return apiFetch(`/users/tutors/${tutorUserId}/students`);
}

export async function adminGetParentStudents(parentUserId) {
  return apiFetch(`/users/parents/${parentUserId}/students`);
}

export async function adminLinkStudentTutor(studentId, tutorUserId) {
  return apiFetch(`/users/students/${studentId}/tutor-link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tutor_user_id: tutorUserId }),
  });
}

export async function adminUnlinkStudentTutor(studentId) {
  return apiFetch(`/users/students/${studentId}/tutor-link`, {
    method: 'DELETE',
  });
}

export async function adminLinkStudentParent(studentId, parentUserId) {
  return apiFetch(`/users/students/${studentId}/parent-link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ parent_user_id: parentUserId }),
  });
}

export async function adminUnlinkStudentParent(studentId, parentUserId) {
  return apiFetch(`/users/students/${studentId}/parent-link/${parentUserId}`, {
    method: 'DELETE',
  });
}

export async function adminGetHealthSummary({ hours = 24 } = {}) {
  const params = new URLSearchParams();
  params.set('hours', String(hours));
  return apiFetch(`/analytics/health/summary?${params.toString()}`, { method: 'GET' });
}

export async function adminGetHealthAlerts({ hours = 24 } = {}) {
  const params = new URLSearchParams();
  params.set('hours', String(hours));
  return apiFetch(`/analytics/health/alerts?${params.toString()}`, { method: 'GET' });
}

export async function adminListQuestionApprovals(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      query.set(key, String(value));
    }
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return apiFetch(`/admin/question-approvals${suffix}`, { method: 'GET' });
}

export async function adminDecideQuestionApprovals(payload) {
  return apiFetch('/admin/question-approvals/decisions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function createTutorUser(payload) {
  return apiFetch('/admin/users/tutor', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function createStudentUser(payload) {
  return apiFetch('/admin/users/student', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function createParentUser(payload) {
  return apiFetch('/admin/users/parent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
